// src/App.tsx
import React, { Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import RequireAuth from './components/RequiredAuth'
import RequireSubscription from './components/RequireSubscription'
import SidebarLayout from './components/SidebarLayout'
import routes from './routesConfig'
import Header from './components/Header'
import { UserProvider } from './contexts/UserContext'
import { CartProvider } from './contexts/CartContext'
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import './App.css';
import { ToastContainer } from "react-toastify";
import BodyClassManager from "./utils/BodyClassManager";

function App() {
  return (
    <UserProvider>
      <CartProvider>
        <BrowserRouter>
          <Header />
          <Suspense fallback={<div>Loading…</div>}>
	 	   	<BodyClassManager />
            <Routes>
              {routes.map(({ path, element, auth, sidebar, requireAdmin, requireSuperAdmin, requireSubscription, externalUserAllowed }) => {
                let node = element;

                if (auth) node = <RequireAuth requireAdmin={requireAdmin} requireSuperAdmin={requireSuperAdmin} externalUserAllowed={externalUserAllowed}>{node}</RequireAuth>;
                if (requireSubscription) node = <RequireSubscription>{node}</RequireSubscription>;
                if (sidebar) node = <SidebarLayout>{node}</SidebarLayout>;

                return <Route key={path} path={path} element={node} />;
              })}

              <Route path="/" element={<Navigate to="/register" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar
              closeOnClick
              pauseOnHover
              draggable
              theme="colored"
            />
          </Suspense>
        </BrowserRouter>
      </CartProvider>
    </UserProvider>
  );
}

export default App;
